import React, { useState } from "react";

import EditContent from "./EditContent";
import ListContent from "./ListContent";

function Menu({
    drawerList,
    changeItemIndex,
    editDrawerList,
    callConfirmChangeDrawerListSort,
    changeEditDrawerListToOriginalDrawerList,
    isListActive,
    toggleList,
    platformType,
    callEmptyAlert,
    lnbRef,
}) {
    return (
        <>
            {isListActive ? (
                <ListContent
                    drawerList={drawerList}
                    toggleList={toggleList}
                    platformType={platformType}
                    callEmptyAlert={callEmptyAlert}
                    lnbRef={lnbRef}
                />
            ) : (
                <EditContent
                    drawerList={editDrawerList}
                    toggleList={toggleList}
                    changeItemIndex={changeItemIndex}
                    callConfirmChangeDrawerListSort={callConfirmChangeDrawerListSort}
                    changeEditDrawerListToOriginalDrawerList={changeEditDrawerListToOriginalDrawerList}
                />
            )}
        </>
    );
}

export default Menu;
